<template>
  <div class="report">
    <div class="top clearfix">
      <div class="fl">
        学年：
        <el-date-picker
          class="search-year"
          v-model="searchYear"
          value-format="yyyy"
          size="small"
          type="year"
          :clearable="false"
          @change="selectLsit()"
        >
        </el-date-picker>
        学期：
        <el-select v-model="searchTerm" size="small" @change="selectLsit()">
          <template v-for="i of dic.schoolTerm">
            <el-option
              :key="i.id"
              :label="i.dicName"
              :value="i.dicCode"
            ></el-option>
          </template>
        </el-select>
      </div>
    </div>
    <div class="content clearfix">
      <div class="top2"><h1>综合信息</h1></div>
      <div class="pie">
        <div>
          <echart :option="resourceOption"></echart>
        </div>
        <div>
          <echart :option="academicListOption"></echart>
        </div>
        <div>
          <echart :option="educationOptions"></echart>
        </div>
        <div>
          <echart :option="ageOptions"></echart>
        </div>
      </div>
      <general-message
        ref="GeneralMessageRef"
        :searchYear="searchYear"
        :searchTerm="searchTerm"
      ></general-message>
    </div>
  </div>
</template>

<script>
import echart from "@/components/echarts.vue";
import GeneralMessage from "@/components/echarts/GeneralMessage";
import { NoDataOption } from "@/utils";
import { mapState } from "vuex";
// import { mixin } from "@/mixin/mixin";
export default {
  // mixins: [mixin],
  components: { GeneralMessage, echart },
  computed: {
    ...mapState(["isAdmin", "userInfo", "dic"]),
    resourceOption() {
      let option = {
        title: [
          {
            text: "资源分布",
            left: "15%",
            bottom: "3%",
            textStyle: {
              fontSize: "16",
              fontWeight: "500",
              color: "#000000",
            },
          },
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "60%",
          top: "center",
          icon: "circle",
          itemWidth: 8,
        },
        series: [
          {
            name: "资源分布",
            type: "pie",
            data: this.resourceData,
            radius: ["0%", "60%"],
            center: ["25%", "50%"],
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
    academicListOption() {
      let option = {
        title: [
          {
            text: "教师职称分布",
            left: "15%",
            bottom: "3%",
            textStyle: {
              fontSize: "16",
              fontWeight: "500",
              color: "#000000",
            },
          },
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "60%",
          top: "center",
          icon: "circle",
          itemWidth: 8,
        },
        series: [
          {
            name: "教师职称分布",
            type: "pie",
            data: this.academicListData,
            radius: ["0%", "60%"],
            center: ["25%", "50%"],
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
    educationOptions() {
      let option = {
        title: [
          {
            text: "教师学历分布",
            left: "15%",
            bottom: "3%",
            textStyle: {
              fontSize: "16",
              fontWeight: "500",
              color: "#000000",
            },
          },
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "60%",
          top: "center",
          icon: "circle",
          itemWidth: 8,
        },
        series: [
          {
            name: "教师学历分布",
            type: "pie",
            data: this.educationList,
            radius: ["0%", "60%"],
            center: ["25%", "50%"],
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
    ageOptions() {
      let option = {
        title: [
          {
            text: "教师年龄分布",
            left: "15%",
            bottom: "3%",
            textStyle: {
              fontSize: "16",
              fontWeight: "500",
              color: "#000000",
            },
          },
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "60%",
          top: "center",
          icon: "circle",
          itemWidth: 8,
        },
        series: [
          {
            name: "教师年龄分布",
            type: "pie",
            data: this.ageList,
            radius: ["0%", "60%"],
            center: ["25%", "50%"],
            label: {
              show: false,
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      return option;
    },
  },
  data() {
    return {
      searchYear: "",
      searchTerm: "",
      resourceData: [],
      academicListData: [],
      educationList: [],
      ageList: [],
    };
  },
  mounted() {},
  created() {
    this.searchYear = this.curYearPro;
    this.searchTerm = this.curTermPro;
    this.getData();
  },
  methods: {
    getData() {
      let params = {
        schoolCode: this.userInfo.schoolCode,
        schoolTerm: this.searchTerm || null,
        schoolYear: this.searchYear || null,
      };
      this.$axios.post("/rpt/getModelCountPie", params).then((res) => {
        if (res && res.data) {
          this.resourceData = res.data;
        } else {
          this.resourceData = [];
        }
      });
      this.$axios
        .post("/rpt/getAcademicCountPie", this.$qs.stringify(params))
        .then((res) => {
          if (res && res.data) {
            this.academicListData = res.data.academicList;
            this.educationList = res.data.educationList;
            this.ageList = res.data.ageList;
          } else {
            this.academicListData = [];
            this.educationList = [];
          }
        });
    },
    selectLsit() {
      this.$nextTick(() => {
        this.$refs.GeneralMessageRef.rankLsit();
        this.getData();
      });
    },
  },
};
</script>

<style lang="less" scoped>
.report {
  padding: 18px;
  border-radius: 8px;
  overflow: hidden;
  .top {
    background: #fff;
    line-height: 60px;
    height: 60px;
    padding: 0px 20px;
    font-size: 15px;
    margin-bottom: 20px;
    border-radius: 8px;
    .el-select {
      margin-right: 20px;
    }
    /deep/.el-input {
      width: none !important;
      .el-input__inner {
        width: none !important;
      }
    }
    .but-black.el-button {
      background: #fff;
      color: #409eff;
      margin-right: 10px;
    }
    .el-button {
      background: @theme-color;
      color: #fff;
      font-size: 14px;
      /deep/.iconfont {
        font-size: 15px;
        margin-right: 5px;
      }
    }
  }
  .content {
    background-color: #fff;
    .top2 {
      padding: 0 20px;
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      color: @theme-color;
    }
    .pie {
      display: flex;
      flex-wrap: wrap;
      > div {
        width: 400px;
        height: 250px;
      }
    }
  }
}
</style>